module.exports = __webpack_public_path__ + "img/zy_button_cancel.6c82bbe4.png";